import "mapbox-gl/dist/mapbox-gl.css"
import React, { useState } from "react"
import ReactMapGL, { Marker, FullscreenControl } from "react-map-gl"

import { MapWrapper } from "./contactStyles"

const Coordinates = {
  latitude: 50.8750642,
  longitude: 2.8771148,
}

const Map = () => {
  const [viewport, setViewport] = useState({
    width: "100%",
    height: "100%",
    latitude: Coordinates.latitude,
    longitude: Coordinates.longitude,
    zoom: 14,
  })
  return (
    <MapWrapper>
      <ReactMapGL
        {...viewport}
        mapboxApiAccessToken={`${process.env.GATSBY_TOKEN_MAPBOX}`}
        mapStyle="mapbox://styles/mapbox/light-v10"
        onViewportChange={nextViewport => setViewport(nextViewport)}
      >
        <div style={{ position: "absolute", right: 12, top: 12 }}>
          <FullscreenControl />
        </div>
        <Marker
          latitude={Coordinates.latitude}
          longitude={Coordinates.longitude}
          offsetLeft={0}
          offsetTop={10}
        >
          <div className="map__marker" />
        </Marker>
      </ReactMapGL>
    </MapWrapper>
  )
}

export default Map
